/*=========================================================================================
  File Name: moduleUnuse.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleUnuseState.js'
import mutations from './moduleUnuseMutations.js'
import actions from './moduleUnuseActions.js'
import getters from './moduleUnuseGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

